module.exports = __webpack_public_path__ + "img/ladda-logo.cda26ac9.svg";